import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { cx } from "shared/utils";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";

interface ISection {
  sectionTitle: ReactNode;
  sectionClassName?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  maxWidth?: string;
  chevron?: ReactNode;
  tooltip?: ReactNode;
  rightElement?: React.ReactNode;
  id?: string;
}

export const Section = ({
  sectionTitle,
  children,
  icon,
  rightElement,
  maxWidth,
  tooltip,
  sectionClassName,
  chevron,
  id
}: ISection) => {
  return (
    // REMOVED PRINT HERE
    // <div className="z-4 relative grid grid-cols-1 print:break-inside-avoid">
    <div
      className={cx(
        "z-4 relative grid grid-cols-1",
        typeof sectionTitle === "string" &&
          sectionTitle.includes("Submission disclosure")
          ? ""
          : "break-inside-avoid"
      )}
      id={id}
    >
      <div className="relative flex h-12 w-full items-center gap-2 rounded-lg border border-alpha-40 bg-background-900 px-4 py-3 break-inside-avoid">
        {icon ? <div>{icon}</div> : null}

        {typeof sectionTitle === "string" ? (
          <>
            <p className="text-sm font-medium text-content-400">
              {sectionTitle}
            </p>
            {tooltip ? (
              <Tooltip placement="right-start">
                <TooltipTrigger>
                  <InfoIcon className="w-4 h-4 text-content-100" />
                </TooltipTrigger>
                <TooltipContent className="w-[525px] rounded-lg border bg-alpha-800 p-4 text-sm text-white">
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            ) : null}
          </>
        ) : (
          sectionTitle
        )}

        {rightElement ? <div className="ml-auto">{rightElement}</div> : null}

        {chevron ? (
          <div className="z-1 absolute -top-px right-4 flex -translate-y-full items-center justify-center rounded-t-lg bg-primary-500 px-3 py-0.5 text-white">
            {chevron}
          </div>
        ) : null}
      </div>

      <div
        className={cx(
          sectionClassName || "md:p-6 pt-3 pl-4 pb-12",
          typeof sectionTitle === "string" &&
            sectionTitle.includes("Submission disclosure")
            ? "break-inside-avoid"
            : ""
        )}
        style={{
          maxWidth
        }}
      >
        {children}
      </div>
    </div>
  );
};
